import React from 'react'

import Project from "../../model2/project/project"
import ProjectIconUI5 from "../../gd-ui/project-icon/project-icon-ui5"
import ProjectSession from "../../model2/project/project-session";

type Props = {
    className?                      : string

    companyId?                      : ID
    projectId?                      : ID | null
    currentProject                  : ID

    maxParents?                     : number

    style?                          : any
    type                            : 'default' | 'v2' | 'v3' | 'v4' | 'v5'
    coloredIcon                     : boolean

    handleRootNavigate              : boolean
    showRootProject                 : boolean
    currentProjectAsLastBreadcrumb  : boolean
    renderLastProjectAsColorPill    : boolean

    onNavigateProject?              : func
    onNavigateCompany?              : func
}

export default class Breadcrumbs extends React.Component<Props> {

    static defaultProps = {
        type                            : 'default',
        coloredIcon                     : false,
        handleRootNavigate              : false,
        showRootProject                 : true,
        currentProjectAsLastBreadcrumb  : false,
        renderLastProjectAsColorPill    : false
    }

    onNavigateProject = (id: ID) => {
        if (id === this.props.currentProject && !this.props.handleRootNavigate) return;
        if (this.props.onNavigateProject) this.props.onNavigateProject(id)
    }

    onNavigateCompany(id: ID) {
        if (this.props.onNavigateCompany) this.props.onNavigateCompany(id)
    }

    renderLastProject(pId: ID, project: ProjectSession) {
        let classes = Classes("breadcrumb-item breadcrumb-root-item", {
            ['gd-c-'+project.color]: this.props.renderLastProjectAsColorPill
        })

        return (
            <div key={pId} className={classes} onClick={this.onNavigateProject.bind(this, project.id)}>
                <ProjectIconUI5 className   = "breadcrumb-project-icon"
                                project     = {project}
                                colorize    = {!this.props.renderLastProjectAsColorPill ? this.props.coloredIcon : false}
                                hint        = {false}/>
                {project.name}
            </div>
        )
    }

    render() {
        let breadcrumbs         = []
        let exceedMaxParents    = false

        if (this.props.projectId !== this.props.currentProject) {
            // @ts-ignore
            const parentProjects = this.props.currentProject ? [this.props.currentProject].concat(gd.session.projects.getAllParents(this.props.currentProject).map((p: Project)=>p.id).reverse()) : []

            // previous parents retrieval method
            // const parentProjects = this.props.currentProject ? gd.tree.findProjectParents(gd.tree.getProject(this.props.currentProject)).map(p=>p.id).concat([this.props.currentProject]).reverse() : []

            let breadcrumbsCollected = false
            parentProjects.map(pId=>{
                if(!breadcrumbsCollected) {
                    const project = pId === 'projects' ? gd.spaces.projects.project : gd.session.projects.get(pId)
                    if (!project) return

                    if (this.props.projectId === pId) breadcrumbsCollected = true

                    if (pId === this.props.currentProject && !this.props.currentProjectAsLastBreadcrumb) {
                        if (!this.props.showRootProject) return;
                        breadcrumbs.unshift(this.renderLastProject(pId, project));
                    } else {
                        if (!this.props.maxParents || breadcrumbs.length < this.props.maxParents) {
                            breadcrumbs.unshift(
                                <div key={pId}
                                     className="breadcrumb-item"
                                     onClick={this.onNavigateProject.bind(this, project.id)}>
                                    {project.name}
                                    <div className="breadcrumb-item-separator i5-big-angle-right"/>
                                </div>
                            )
                        }

                        exceedMaxParents = !!this.props.maxParents && breadcrumbs.length >= this.props.maxParents
                    }
                }
            })
        }

        //add company if specified
        if (this.props.companyId && this.props.currentProject) {
            breadcrumbs.unshift(
                <div key={this.props.companyId}
                     className="breadcrumb-item company"
                     onClick={this.onNavigateCompany.bind(this, this.props.companyId)}>
                    {gd.session.companies.get(this.props.companyId).name}
                    <div className="breadcrumb-item-separator i5-big-angle-right"/>
                </div>
            )
        }

        const classes = Classes("gd-breadcrumbs-block", this.props.type+"-type", "breadcrumbs-"+breadcrumbs.length, this.props.className, {
            "exceed-max-parents": exceedMaxParents,
            "empty"             : breadcrumbs.length <= 0
        })

        return <div className={classes} style={this.props.style}>{breadcrumbs}</div>
    }
}